export default "__VITE_ASSET__25dd1e15__"